import { Controller } from '@hotwired/stimulus';
const axios = require('axios');
const SC = require('soundcloud');

export default class extends Controller {
	static targets = ['podcast', 'container', 'lightbox', 'lightboxContent'];

	connect() {
		SC.initialize({
			client_id: 'gsPNGqVqXY4QlaFqDv7WBWglYHdTPsh6',
		});

		this.boundCloseAnywhere = this.closeAnywhere.bind(this);
		this.containerTarget.addEventListener('click', this.boundCloseAnywhere);
	}

	open(e) {
		e.preventDefault();

		const podcastUrl = e.currentTarget.dataset.podcastUrl;
		const that = this;

		SC.oEmbed(podcastUrl, {
			auto_play: false,
		})
			.then(function (embed) {
				that.lightboxContentTarget.innerHTML = embed.html;
				that.lightboxTarget.classList.remove('hidden');
				that.lightboxTarget.classList.add('flex');
			})
			.catch(function (error) {
				console.log(error);
			});
	}

	close(e) {
		e.preventDefault();
		console.log(e);

		this.lightboxTarget.classList.remove('flex');
		this.lightboxTarget.classList.add('hidden');
		this.lightboxContentTarget.innerHTML = '';
	}

	closeAnywhere(e) {
		if (e.target != this.lightboxContentTarget && !this.lightboxContentTarget.contains(e.target)) {
			this.close(e);
		}
	}
}
